import type { SizeEnum } from '@mts/components/Loading/src/typing';
import type { Directive } from 'vue';
import { createLoading } from '@mts/components/Loading';

const ATTR_TIP = 'loading-tip';
const ATTR_SIZE = 'loading-size';

const SIZE_MAP: Recordable<SizeEnum> = {
  default: 'default',
  small: 'small',
  large: 'large',
};

const getLoadingConfig = (el: HTMLElement, binding: any) => {
  const tip = el.getAttribute(ATTR_TIP);
  const sizeAttr = el.getAttribute(ATTR_SIZE) || 'large';

  const size = SIZE_MAP[sizeAttr.toLowerCase()] || 'large';
  return { tip: tip || undefined, size, loading: !!binding.value, absolute: true };
};

const loadingDirective: Directive = {
  mounted(el, binding) {
    const config = getLoadingConfig(el, binding);
    const instance = createLoading(config, el);

    const instanceKey = Symbol('loadingInstance');
    el[instanceKey] = instance;

    el._loadingInstanceKey = instanceKey;
  },

  updated(el, binding) {
    const instanceKey = el._loadingInstanceKey as symbol;
    if (!instanceKey) return;

    const instance = el[instanceKey];
    if (!instance) return;

    if (binding.oldValue !== binding.value) {
      instance.setLoading?.(!!binding.value);
    }

    const newTip = el.getAttribute(ATTR_TIP);
    if (newTip !== instance.tip) {
      instance.setTip?.(newTip || '');
    }
  },

  unmounted(el) {
    const instanceKey = el._loadingInstanceKey as symbol;
    if (!instanceKey) return;

    const instance = el[instanceKey];
    if (instance) {
      delete el[instanceKey];
      delete el._loadingInstanceKey;

      requestAnimationFrame(() => {
        instance.destroy?.();
      });
    }
  },
};

export default loadingDirective;
